import BaseCommand from "@/models/api/commands/BaseCommand";

export class RemoveFeesCommand extends BaseCommand {
  CommandName = "RemoveFees";
  Command = undefined;
  constructor(sessionId: string, operationId: string) {
    super(sessionId, operationId);
  }
}
